import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { calculateGasHeatYearCost } from '../services/FinancialsPublicService';

export const useFinancialsPublicCalculateGasHeatYearCost = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(calculateGasHeatYearCost, 'requestBody', 'data'),
      'data',
      'houseType',
      'neighbourHoodId',
      'address',
      'gasRegion',
      'heatRegion',
      'boilerPurchaseCosts',
      'boilerMaintenanceCosts',
      'boilerPurchaseWriteOff',
      'heatExchangerPurchaseCosts',
      'gasUsage',
      'heatUsage',
      'housingIsRental',
      'carbonFootprint',
      'addressHasWarmthConnection',
      'usingDefaultGasConsumption',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'houseType',
          'neighbourHoodId',
          'address',
          'gasRegion',
          'heatRegion',
          'boilerPurchaseCosts',
          'boilerMaintenanceCosts',
          'boilerPurchaseWriteOff',
          'heatExchangerPurchaseCosts',
          'gasUsage',
          'heatUsage',
          'housingIsRental',
          'carbonFootprint',
          'addressHasWarmthConnection',
          'usingDefaultGasConsumption',
        ],
      },
    ],
  },
);
